module.exports = __webpack_public_path__ + "static/img/seven.bf3c9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-seven/seven.png
// module id = /096
// module chunks = 0